/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreditPrice } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetCreditConsumptionHistoryResponse } from '../models';
// @ts-ignore
import type { GetCreditPricesResponse } from '../models';
// @ts-ignore
import type { GetCreditValuesResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateCreditPriceBody } from '../models';
// @ts-ignore
import type { UseCreditsBody } from '../models';
// @ts-ignore
import type { UseCreditsResponse } from '../models';
/**
 * CreditsApiApi - axios parameter creator
 */
export const CreditsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [creditsCount] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiAdminAllocateCreditToUsers: async (creditsCount?: number, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/credits-allocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (creditsCount !== undefined) {
                localVarQueryParameter['credits_count'] = creditsCount;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetAdminCreditPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/credit-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetCreditConsumptionHistory: async (page?: number, pageSize?: number, transactionType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credits/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transaction_type'] = transactionType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetCreditCost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credits/cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {string} key 
         * @param {UpdateCreditPriceBody} updateCreditPriceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiUpdateAdminCreditPrice: async (category: string, key: string, updateCreditPriceBody: UpdateCreditPriceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('creditsApiUpdateAdminCreditPrice', 'category', category)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('creditsApiUpdateAdminCreditPrice', 'key', key)
            // verify required parameter 'updateCreditPriceBody' is not null or undefined
            assertParamExists('creditsApiUpdateAdminCreditPrice', 'updateCreditPriceBody', updateCreditPriceBody)
            const localVarPath = `/admin/credit-prices/{category}/{key}`
                .replace('{category}', encodeURIComponent(String(category)))
                .replace('{key}', encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCreditPriceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UseCreditsBody} useCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiUseCredits: async (useCreditsBody: UseCreditsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'useCreditsBody' is not null or undefined
            assertParamExists('creditsApiUseCredits', 'useCreditsBody', useCreditsBody)
            const localVarPath = `/credits/use`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(useCreditsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditsApiApi - functional programming interface
 */
export const CreditsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [creditsCount] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiAdminAllocateCreditToUsers(creditsCount?: number, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiAdminAllocateCreditToUsers(creditsCount, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiAdminAllocateCreditToUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiGetAdminCreditPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCreditPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiGetAdminCreditPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiGetAdminCreditPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [transactionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiGetCreditConsumptionHistory(page?: number, pageSize?: number, transactionType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCreditConsumptionHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiGetCreditConsumptionHistory(page, pageSize, transactionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiGetCreditConsumptionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiGetCreditCost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCreditValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiGetCreditCost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiGetCreditCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} category 
         * @param {string} key 
         * @param {UpdateCreditPriceBody} updateCreditPriceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiUpdateAdminCreditPrice(category: string, key: string, updateCreditPriceBody: UpdateCreditPriceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiUpdateAdminCreditPrice(category, key, updateCreditPriceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiUpdateAdminCreditPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UseCreditsBody} useCreditsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditsApiUseCredits(useCreditsBody: UseCreditsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UseCreditsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditsApiUseCredits(useCreditsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditsApiApi.creditsApiUseCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CreditsApiApi - factory interface
 */
export const CreditsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CreditsApiApiCreditsApiAdminAllocateCreditToUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiAdminAllocateCreditToUsers(requestParameters: CreditsApiApiCreditsApiAdminAllocateCreditToUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.creditsApiAdminAllocateCreditToUsers(requestParameters.creditsCount, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetAdminCreditPrices(options?: RawAxiosRequestConfig): AxiosPromise<GetCreditPricesResponse> {
            return localVarFp.creditsApiGetAdminCreditPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreditsApiApiCreditsApiGetCreditConsumptionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetCreditConsumptionHistory(requestParameters: CreditsApiApiCreditsApiGetCreditConsumptionHistoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCreditConsumptionHistoryResponse> {
            return localVarFp.creditsApiGetCreditConsumptionHistory(requestParameters.page, requestParameters.pageSize, requestParameters.transactionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiGetCreditCost(options?: RawAxiosRequestConfig): AxiosPromise<GetCreditValuesResponse> {
            return localVarFp.creditsApiGetCreditCost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreditsApiApiCreditsApiUpdateAdminCreditPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiUpdateAdminCreditPrice(requestParameters: CreditsApiApiCreditsApiUpdateAdminCreditPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditPrice> {
            return localVarFp.creditsApiUpdateAdminCreditPrice(requestParameters.category, requestParameters.key, requestParameters.updateCreditPriceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreditsApiApiCreditsApiUseCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditsApiUseCredits(requestParameters: CreditsApiApiCreditsApiUseCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UseCreditsResponse> {
            return localVarFp.creditsApiUseCredits(requestParameters.useCreditsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for creditsApiAdminAllocateCreditToUsers operation in CreditsApiApi.
 */
export interface CreditsApiApiCreditsApiAdminAllocateCreditToUsersRequest {
    readonly creditsCount?: number

    readonly userId?: string
}

/**
 * Request parameters for creditsApiGetCreditConsumptionHistory operation in CreditsApiApi.
 */
export interface CreditsApiApiCreditsApiGetCreditConsumptionHistoryRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly transactionType?: string
}

/**
 * Request parameters for creditsApiUpdateAdminCreditPrice operation in CreditsApiApi.
 */
export interface CreditsApiApiCreditsApiUpdateAdminCreditPriceRequest {
    readonly category: string

    readonly key: string

    readonly updateCreditPriceBody: UpdateCreditPriceBody
}

/**
 * Request parameters for creditsApiUseCredits operation in CreditsApiApi.
 */
export interface CreditsApiApiCreditsApiUseCreditsRequest {
    readonly useCreditsBody: UseCreditsBody
}

/**
 * CreditsApiApi - object-oriented interface
 */
export class CreditsApiApi extends BaseAPI {
    /**
     * 
     * @param {CreditsApiApiCreditsApiAdminAllocateCreditToUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiAdminAllocateCreditToUsers(requestParameters: CreditsApiApiCreditsApiAdminAllocateCreditToUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiAdminAllocateCreditToUsers(requestParameters.creditsCount, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiGetAdminCreditPrices(options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiGetAdminCreditPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreditsApiApiCreditsApiGetCreditConsumptionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiGetCreditConsumptionHistory(requestParameters: CreditsApiApiCreditsApiGetCreditConsumptionHistoryRequest = {}, options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiGetCreditConsumptionHistory(requestParameters.page, requestParameters.pageSize, requestParameters.transactionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiGetCreditCost(options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiGetCreditCost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreditsApiApiCreditsApiUpdateAdminCreditPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiUpdateAdminCreditPrice(requestParameters: CreditsApiApiCreditsApiUpdateAdminCreditPriceRequest, options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiUpdateAdminCreditPrice(requestParameters.category, requestParameters.key, requestParameters.updateCreditPriceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreditsApiApiCreditsApiUseCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public creditsApiUseCredits(requestParameters: CreditsApiApiCreditsApiUseCreditsRequest, options?: RawAxiosRequestConfig) {
        return CreditsApiApiFp(this.configuration).creditsApiUseCredits(requestParameters.useCreditsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

